import React from 'react';
import { useTestAB } from '@catalogo/core-experiments';

export const withFastDeliveryExperiment = Component => props => {
  const experiment = useTestAB('CAT_DISC_FAST_DELIVERY');

  return <Component {...props} fastDeliveryExperiment={experiment} />;
};
